/**
 * 현재 포커스된 "입력 요소"의 포커스를 해제한다.
 *
 * 폼이 제출돼 다음 동작으로 넘어갈 때 호출한다. 제출 직전 입력창에 포커스와 소프트
 * 키보드가 그대로 남는 현상을 정리하기 위한 유틸.
 *
 * - input / textarea / contenteditable 이 활성일 때만 blur 한다.
 *   Enter 로 제출한 경우 activeElement 는 항상 그 입력창이므로 정리된다.
 *   버튼을 탭/클릭해 제출한 경우는 플랫폼에 따라 갈린다 — 데스크톱은 버튼이 focus 를
 *   받아 no-op 이지만, iOS WKWebView 등에서는 탭이 버튼에 focus 를 주지 않아 입력창이
 *   여전히 활성일 수 있고 그때도 blur 된다(진행 시 키보드 정리이므로 의도된 동작).
 * - activeElement 가 버튼 등 비입력 요소면 아무 것도 하지 않는다.
 *
 * @returns 편집 요소(input/textarea/contenteditable)를 실제로 blur 했으면 true, 아니면 false.
 *   ⚠️ "소프트 키보드가 떠 있었다"와 동일하지 않다 — 데스크톱/하드웨어 키보드에서도
 *   편집 요소가 활성이면 true 를 반환한다. "편집 요소를 blur 했는지"의 신호로만 사용할 것.
 */
export function blurActiveElement(): boolean {
  const active = document.activeElement;
  if (
    active instanceof HTMLInputElement ||
    active instanceof HTMLTextAreaElement ||
    (active instanceof HTMLElement && active.isContentEditable)
  ) {
    active.blur();
    return true;
  }
  return false;
}
